import { client } from '@/services/fetch.js'
import { toast } from '@/services/toast.js'
import TranslationProvider from '@/provider/translations.js'

import { buildFilterQuery } from '@/libs/utils.js'
import { getDenominationFromUser } from '@/libs/utils/users.js'

const vrValues = [
  'default-vr',
  'cmb'
]

export const getUserByReferenceAndVr = async (reference, vr) => {

  if (!reference || !vrValues.includes(vr)) {
    return []
  }

  try {
    let url = `/custom/${vr}/search-users?reference=${reference}&excludeData=0`
    const response = await client.get(url)
    return response.data[0] ?? []
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
      }
}

export const getUserByReference = async (reference) => {
  try {
    let url = `/users?module=polls-cc&reference=${reference}`
    const response = await client.get(url)
    return response.data[0] ?? []
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
      }
}

export const searchUsers = async (vr, params = {}) => {
  if (!vrValues.includes(vr)) {
    return []
  }

  try {
    let url = `/custom/${vr}/search-users?sortBy=username&direction=asc`

    const query = buildFilterQuery(params)
    if (query) {
      url += `${query}`
    }

    const response = await client.get(url)

    response.data.forEach(user => {
      user.denomination = getDenominationFromUser(user)
    })

    return response
  } catch (error) {
    toast.create(TranslationProvider.getTrans('app.network_error'), 'error')
  }
}

export const getFullNameByUser = (option) => {
  if (option['personRelations']){
    if (option['personRelations'][0] && option['personRelations'][0]['person']){
      const person = option['personRelations'][0]['person']
      if (person['firstName'] && person['lastName']){
        return `${person['firstName']} ${person['lastName']}`
      }
    }
  }

  if (option['denomination']){
    return option.denomination
  }

  return option.username
}
